// utils/getMagentoProduct.js
import { ADD_TO_CART } from 'Util/Product';
import { magentoProductTransform, transformParameters } from 'Util/Product/Transform';

/**
 * Prepares a product object in the shape needed for cart/wishlist actions (Magento GraphQL).
 *
 * @param {object} args
 *   - product: Magento product object
 *   - quantity: number or object (grouped)
 *   - enteredOptions: array of { uid, value } for custom/bundle/text options
 *   - selectedOptions: array of selected option IDs (dropdowns, radios, etc)
 *   - parameters: object of configurable attribute selections
 *   - attributes: raw attributes object (optional, fallback: product.attributes)
 * @returns {object[]} Array of product objects for mutation
 * @namespace Bodypwa/Util/Product/MagentoProduct/getMagentoProduct
 */
export function getMagentoProduct({
    product,
    quantity = 1,
    enteredOptions = [],
    selectedOptions = [],
    parameters = {},
    attributes // Optional, fallback: product.attributes
}) {
    if (!product) {
        return [];
    }

    const attrs = attributes || product.attributes || {};

    // For configurable products, transform attribute parameters
    const configurableOptions = transformParameters(parameters, attrs);

    // Use the same helper as in container to get the final product array
    return magentoProductTransform(
        ADD_TO_CART,
        product,
        quantity,
        enteredOptions,
        [
            ...selectedOptions,
            ...configurableOptions
        ]
    );
}
